<template>
  <div>
    <h1 class="page-header">Category</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label">Name Kh </label>
                <div class="col-md-7">
                  <input
                    ref="category_name_kh"
                    v-model="model.category_name_kh"
                    type="text"
                    class="form-control kh-font"
                    :class="{ 'is-invalid': errors.has('category_name_kh') }"
                    placeholder="Enter name kh"
                  />
                  <div class="invalid-feedback" v-if="errors.has('category_name_kh')">
                    {{ errors.first('category_name_kh') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label "
                  >Name En <span class="text-danger">*</span>
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.category_name_en"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('category_name_en') }"
                    placeholder="Enter name en"
                  />
                  <div class="invalid-feedback" v-if="errors.has('category_name_en')">
                    {{ errors.first('category_name_en') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label ">Rate <span class="text-danger">*</span> </label>
                <div class="col-md-7">
                  <input
                    v-model="model.category_rate"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('category_rate') }"
                    placeholder="Enter rate"
                  />
                  <div class="invalid-feedback" v-if="errors.has('category_rate')">
                    {{ errors.first('category_rate') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label "
                  >Date Range <span class="text-danger">*</span>
                </label>
                <div class="col-md-7">
                  <div class="row row-space-10">
                    <div class="col-md-6">
                      <ts-date-picker-input v-model="model.category_effective_date" placeholder="Effective date" />
                    </div>
                    <div class="col-md-6">
                      <ts-date-picker-input v-model="model.category_expiry_date" placeholder="Expiry date" />
                    </div>
                  </div>
                  <div style="color:#cc4946;margin:4px 0 0">
                    {{ errors.first('category_expiry_date') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row text-right">
            <div class="col-lg-12">
              <ts-button color="primary" :disabled="saving" :waiting="saving" @click="update">
                Update
              </ts-button>
              <ts-button class="ml-2" @click="$router.push({ name: 'category' })">
                Cancel
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import apicategory from '@/api/inventory/category'

export default {
  name: 'category-edit-form',
  beforeRouteEnter: async (to, from, next) => {
    let response = await apicategory.find(to.params.id)
    to.params.editData = response.data
    next(vm => vm.setEditData())
  },
  props: ['editData'],
  data() {
    return {
      model: {
        category_id: 0,
        category_name_kh: null,
        category_name_en: null,
        category_rate: null,
        category_effective_date: null,
        category_expiry_date: null
      },
      errors: new Errors(),
      saving: false
    }
  },
  mounted() {
    this.$refs.category_name_kh.focus()
  },
  methods: {
    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('inventory/category/updateCategory', this.model)

        this.$toasted.success(response.message)
        this.saving = false
        this.$router.push('/categories')
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.saving = false
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEditData() {
      this.model.category_id = this.editData.category_id
      this.model.category_name_kh = this.editData.category_name_kh
      this.model.category_name_en = this.editData.category_name_en
      this.model.category_rate = parseFloat(this.editData.category_rate, 10)
      this.model.category_effective_date = this.editData.category_effective_date
      this.model.category_expiry_date = this.editData.category_expiry_date
    }
  }
}
</script>
